export default "__VITE_ASSET__IbSpj6tn__"